import React from "react";
import { useSelector } from "react-redux";
import PriceText from "components/PriceText";
import { showDiscountPercentSelector } from "selectors/quantityGridSelector";

const TableFooter = ({ sizeBreaks, attrsList, headers, isMinOrderCheckApplicable }) => {
  return (
    <tfoot className="s_pricing_wrap" style={{ display: "table-footer-group" }}>
      <AttrWiseRows
        sizeBreaks={sizeBreaks}
        attrsList={attrsList}
        headers={headers}
        isMinOrderCheckApplicable={isMinOrderCheckApplicable}
      />
    </tfoot>
  );
};

const AttrWiseRows = ({ sizeBreaks, attrsList, headers, isMinOrderCheckApplicable }) => {
  return attrsList?.map(attrName => (
    <tr key={attrName} className="s_pricing_row">
      <td className="attribute_col" style={{ display: "table-cell" }}>
        {attrName}
      </td>

      <AttrbuteWisePrices
        sizeBreaks={sizeBreaks}
        attrName={attrName}
        headers={headers}
      />
      { isMinOrderCheckApplicable && <td className="table-last-col"></td> }
    </tr>
  ));
};

const AttrbuteWisePrices = ({ sizeBreaks, attrName, headers, isMinOrderCheckApplicable }) => {
  const showDiscountPercent = useSelector(showDiscountPercentSelector);
  const attrRow = sizeBreaks?.get(attrName);
  const attrSizes = headers;

  if (!attrSizes || !attrRow) return <></>;

  return attrSizes.map(sizeName => {
    const smsbId = attrRow.getIn([sizeName, "stock_quantity", "id"]);
    const isDiscounted = attrRow.getIn([sizeName, "stock_quantity", "is_discounted"]);
    const pbDiscounted = attrRow.getIn([sizeName, "stock_quantity", "pb_discounted"]);
    const staticDiscounted = attrRow.getIn([sizeName, "stock_quantity", "static_discounted"]);
    const pbPercentOff = attrRow.getIn([sizeName, "stock_quantity", "pb_percent_off"]);
    const displayWholesalePrice = attrRow.getIn([sizeName, "stock_quantity", "display_wholesale_price"]);
    const displayEffectiveWholesalePrice = attrRow.getIn([
      sizeName,
      "stock_quantity",
      "display_effective_wholesale_price"
    ]);
    const retailPriceFormatted = attrRow.getIn([sizeName, "stock_quantity", "retail_price_formatted"]);
    const discountedPriceClass = pbDiscounted ? "c_green" : staticDiscounted ? "c_blue" : "";

    return (
      <td key={smsbId}>
        <div className="price_value">
          <div>
            <PriceText
              isDiscounted={isDiscounted}
              pbDiscounted={pbDiscounted}
              pbPercentOff={pbPercentOff}
              showWsRange={false}
              displayWholesalePrice={displayWholesalePrice}
              discountedDisplayWholesalePrice={displayEffectiveWholesalePrice}
              discountedPriceClass={discountedPriceClass}
              showDiscountPercent={showDiscountPercent}
            />
          </div>
          { isMinOrderCheckApplicable &&
            retailPriceFormatted &&
            <div> `(${retailPriceFormatted})` </div>
          }
        </div>
      </td>
    );
  });
};

export default React.memo(TableFooter);
